/* optionSets.js naming convention is collectionField,
e.g. matterTypes means that "types" is a field within the "matter" collection. */

import { SelectOption } from './components/types';
import {
  InsuranceClaimStatus,
  MatterStatus,
  MatterType,
  TransactionPaymentMethod,
  TransactionType,
} from '@shared/types';

export const matterTypeSelectOptions: SelectOption<MatterType>[] = [
  { label: 'ARAG', value: 'ARAG' },
  { label: 'MetLife', value: 'MetLife' },
  { label: 'LegalEase', value: 'LegalEase' },
  { label: 'Other Insurance', value: 'OtherInsurance' },
  { label: 'FlatFee', value: 'FlatFee' },
  { label: 'Hourly', value: 'Hourly' },
  { label: 'Contingency', value: 'Contingency' },
  { label: 'Pro Bono', value: 'Pro Bono' },
  { label: 'Subscription', value: 'Subscription' },
  { label: `Don't Know`, value: `Don't Know` },
];

export const matterStatusSelectOptions: SelectOption<MatterStatus>[] = [
  { label: 'New', value: 'new' },
  { label: 'Waiting Room', value: 'pendingEngagement' },
  { label: 'Engagement Letter Sent', value: 'engagementLetterSent' },
  { label: 'Open', value: 'open' },
  { label: 'Earned but Not Closed', value: 'earnedButNotClosed' },
  { label: 'Closed', value: 'closed' },
  { label: 'Rejected', value: 'rejectedByAttorney' },
];

export const usStates = [
  { label: 'Alabama', value: 'Alabama' },
  { label: 'Alaska', value: 'Alaska' },
  { label: 'Arizona', value: 'Arizona' },
  { label: 'Arkansas', value: 'Arkansas' },
  { label: 'California', value: 'California' },
  { label: 'Colorado', value: 'Colorado' },
  { label: 'Connecticut', value: 'Connecticut' },
  { label: 'Delaware', value: 'Delaware' },
  { label: 'Florida', value: 'Florida' },
  { label: 'Georgia', value: 'Georgia' },
  { label: 'Hawaii', value: 'Hawaii' },
  { label: 'Idaho', value: 'Idaho' },
  { label: 'Illinois', value: 'Illinois' },
  { label: 'Indiana', value: 'Indiana' },
  { label: 'Iowa', value: 'Iowa' },
  { label: 'Kansas', value: 'Kansas' },
  { label: 'Kentucky', value: 'Kentucky' },
  { label: 'Louisiana', value: 'Louisiana' },
  { label: 'Maine', value: 'Maine' },
  { label: 'Maryland', value: 'Maryland' },
  { label: 'Massachusetts', value: 'Massachusetts' },
  { label: 'Michigan', value: 'Michigan' },
  { label: 'Minnesota', value: 'Minnesota' },
  { label: 'Mississippi', value: 'Mississippi' },
  { label: 'Missouri', value: 'Missouri' },
  { label: 'Montana', value: 'Montana' },
  { label: 'Nebraska', value: 'Nebraska' },
  { label: 'Nevada', value: 'Nevada' },
  { label: 'New Hampshire', value: 'New Hampshire' },
  { label: 'New Jersey', value: 'New Jersey' },
  { label: 'New Mexico', value: 'New Mexico' },
  { label: 'New York', value: 'New York' },
  { label: 'North Carolina', value: 'North Carolina' },
  { label: 'North Dakota', value: 'North Dakota' },
  { label: 'Ohio', value: 'Ohio' },
  { label: 'Oklahoma', value: 'Oklahoma' },
  { label: 'Oregon', value: 'Oregon' },
  { label: 'Pennsylvania', value: 'Pennsylvania' },
  { label: 'Rhode Island', value: 'Rhode Island' },
  { label: 'South Carolina', value: 'South Carolina' },
  { label: 'South Dakota', value: 'South Dakota' },
  { label: 'Tennessee', value: 'Tennessee' },
  { label: 'Texas', value: 'Texas' },
  { label: 'Utah', value: 'Utah' },
  { label: 'Vermont', value: 'Vermont' },
  { label: 'Virginia', value: 'Virginia' },
  { label: 'Washington', value: 'Washington' },
  { label: 'West Virginia', value: 'West Virginia' },
  { label: 'Wisconsin', value: 'Wisconsin' },
  { label: 'Wyoming', value: 'Wyoming' },
  { label: 'American Samoa', value: 'American Samoa' },
  { label: 'Guam', value: 'Guam' },
  { label: 'Northern Mariana Islands', value: 'Northern Mariana Islands' },
  { label: 'Puerto Rico', value: 'Puerto Rico' },
  { label: 'U.S. Virgin Islands', value: 'U.S. Virgin Islands' },
  {
    label: 'U.S. Minor Outlying Islands',
    value: 'U.S. Minor Outlying Islands',
  },
];

export const transactionPaymentMethod: SelectOption<TransactionPaymentMethod>[] =
  [
    { label: 'Card', value: 'card' },
    { label: 'Cash', value: 'cash' },
    { label: 'Check', value: 'check' },
    { label: 'eCheck', value: 'eCheck' },
    { label: 'Unknown', value: 'unknown' },
  ];

export const transactionType: SelectOption<TransactionType>[] = [
  { label: 'Retainer Transfer', value: 'retainerTransfer' },
  { label: 'Retainer Deposit', value: 'retainerDeposit' },
  { label: 'Invoice Payment', value: 'invoicePayment' },
  { label: 'Insurance', value: 'insurance' },
  { label: 'Invoice Payment Refund', value: 'refundFromOperating' },
  { label: 'Retainer Refund', value: 'refundFromTrust' },
  { label: 'Dispute', value: 'dispute' },
  { label: 'Unknown', value: 'unknown' },
];

export const manualClaimStatusSelectOptions: SelectOption<InsuranceClaimStatus>[] =
  [
    { value: 'readyToFile', label: 'Ready to File' },
    { value: 'submitted', label: 'Submitted' },
    { value: 'approved', label: 'Approved' },
    { value: 'paymentPending', label: 'Payment Pending' },
    { value: `paid`, label: `Paid` },
    { value: `denied`, label: `Denied` },
  ];

export const allClaimStatusSelectOptions: SelectOption<InsuranceClaimStatus>[] =
  [
    ...manualClaimStatusSelectOptions,
    { value: 'enqueuedForAutoFiling', label: 'Enqueued for Autofiling' },
    { value: 'autoFilingInProgress', label: 'Autofiling In Progress' },
    { value: 'autoFilingFailed', label: 'Autofiling Failed' },
  ];

/**
 * Maps two-letter US state codes to full state names
 * @param stateCode - Two-letter state code (e.g., 'CA', 'NY')
 * @returns Full state name or undefined if not found
 */
export const getStateNameFromCode = (stateCode: string): string | undefined => {
  const stateCodeMap: Record<string, string> = {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
    AS: 'American Samoa',
    GU: 'Guam',
    MP: 'Northern Mariana Islands',
    PR: 'Puerto Rico',
    VI: 'U.S. Virgin Islands',
    UM: 'U.S. Minor Outlying Islands',
  };

  return stateCodeMap[stateCode.toUpperCase()];
};
